import { Skeleton } from "antd-mobile";
import { homeAtom } from "@/atoms/home";
import WarningTips from "./WarningTips";

// 骨架屏样式常量
const SKELETON_STYLES = {
  current3: { "--width": "100%", "--height": "50px", "--border-radius": "10px" },
};

const WeatherWarning: React.FC<any> = () => {
  const homeData = useAtomValue(homeAtom);
  const current = homeData?.data?.current ?? {};
  return <>{isEmptyType(current) ? <Skeleton animated style={SKELETON_STYLES.current3} /> : <WarningTips />}</>;
};

export default WeatherWarning;
